import React from 'react';
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {Field} from 'formik'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import {LocalizationProvider} from '@mui/x-date-pickers'

import {addHours, addYears} from '../../../utils'

import {StaticDatePickerField, DatePickerField, TimePickerField} from '../../generics'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'


const styles = {
  container: css`
    display: flex; 
    gap: 16px; 
    flex-wrap: wrap; 
    margin-bottom: 24px;
  `,
  timeContainer: css`
    display: flex;
    gap: 20px;
  `,
  header: css`
    font-weight: 500;
    font-size: 1.2rem;
    margin-bottom: 0;
  `,
  caption: css`
    font-size: 0.9rem;
    color: #636363;
    margin-bottom: 30px;
    font-weight: 500;
  `,
  recurringContainer: css`
    display: flex;
    align-items: top;
    gap: 20px;
  `,
  menuItem: css`
    font-size: 0.9rem;
    font-weight: 500;
  `
}


const repeatOptions = {
  never:    "Doesn't Repeat",
  daily:    "Daily",
  weekly:   "Weekly",
  biweekly: "Every Two Weeks",
  monthly:  "Monthly",
}



const EventFormDateAndTime = ({ values, errors, touched, setFieldValue }) => {

  function updateReoccurence(e) {
    setFieldValue('repeats', e.target.value)
  }


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div css={styles.container}>
        <Field name='date' component={StaticDatePickerField} />

        <div css={styles.timeContainer}>
          <FormControl fullWidth>
            <Field
              name='start_time'
              label='Start Time'
              component={TimePickerField}
              onChange={newVal => {
                if (!touched.end_time && newVal > values.end_time) {
                  setFieldValue('end_time', addHours(newVal, 2));
                }
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <Field
              name='end_time'
              label='End Time'
              component={TimePickerField}
            />
          </FormControl>
        </div>


        {!values.performanceId && (
          <div>
            <h4 css={styles.header}>
              Recurring Event?
            </h4>
            
            <p css={styles.caption}>
              For a recurring schedule—such as every Tuesday at 8 PM for 
              the next four weeks—use the section below to create all events at once.
            </p>

            <div css={styles.recurringContainer}>
              <FormControl fullWidth>
                <InputLabel variant='filled' shrink={true}>
                  Recurrence
                </InputLabel>
                
                <Select
                  value={values.repeats}
                  label='Recurrence'
                  variant='filled'
                  onChange={updateReoccurence}
                >
                  {Object.entries(repeatOptions).map(([key, label]) => (
                    <MenuItem key={key} value={key} css={styles.menuItem}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <Field
                  name='repeat_end'
                  label='Reoccurs Until'
                  component={DatePickerField}
                  disabled={values.repeats === 'never'}
                  minDate={values.date}
                  maxDate={addYears(new Date(), 1)}
                />
              </FormControl>
            </div>
          </div>
        )}
      </div>
    </LocalizationProvider>
  )
}


export default EventFormDateAndTime


